<!-- <div> -->
  <nav
    class="sidebar"
    sidebar-anyclick-close=""
    [class.show-scrollbar]="settings.layout.asideScrollbar"
  >
    <ul class="nav top-section-links">
      <li class="has-user-block"></li>
      <ng-template ngFor let-item [ngForOf]="menuItems" let-i="index">
        <!-- Items without privilege gate (e.g. Superadmin filtered in constructor) -->
        <ng-container *ngIf="!item.privilege">
          <li
            [ngClass]="{
              'nav-heading': item.heading,
              active: item.link && isActiveRoute(item.link)
            }"
            [routerLinkActive]="item.submenu ? [] : ['active']"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <ng-template [ngIf]="item.heading">
              <span>{{ (item.translate | translate) || item.text }}</span>
            </ng-template>

            <!-- Leaf item -->
            <ng-template [ngIf]="!item.heading && !item.submenu">
              <a
                [routerLink]="item.link"
                [attr.route]="item.link"
                title="{{ item.text }}"
              >
                <span
                  class="pull-right"
                  *ngIf="item.alert"
                  [ngClass]="item.label || 'label label-success'"
                  >{{ item.alert }}</span
                >
                <em class="{{ item.icon }}" *ngIf="item.icon"></em>
                <span>{{ (item.translate | translate) || item.text }}</span>
              </a>
            </ng-template>

            <!-- Parent with submenu (Superadmin, Settings, …) -->
            <ng-template [ngIf]="!item.heading && item.submenu">
              <a
                class="nav-item"
                title="{{ item.text }}"
                [routerLink]="item.link"
                [attr.route]="item.link"
                (click)="ensureSubmenuOpen(item)"
              >
                <span class="pull-right">
                  <em
                    class="fa cursor-pointer"
                    style="padding: 0 4px"
                    [ngClass]="
                      isSubmenuOpen(item) ? 'fa-angle-down' : 'fa-angle-left'
                    "
                    (click)="toggleSubmenu($event, item)"
                  ></em>
                </span>
                <em class="{{ item.icon }}" *ngIf="item.icon"></em>
                <span>{{ (item.translate | translate) || item.text }}</span>
              </a>
              <ul
                class="nav sidebar-subnav"
                [class.in]="isSubmenuOpen(item)"
                [style.display]="isSubmenuOpen(item) ? 'block' : 'none'"
              >
                <li class="sidebar-subnav-header">{{ item.text }}</li>
                <li
                  *ngFor="let sub of item.submenu"
                  [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{ exact: sub.link === '/superadmin' }"
                >
                  <a
                    [routerLink]="sub.link"
                    [attr.route]="sub.link"
                    title="{{ sub.text }}"
                  >
                    <em class="{{ sub.icon }}" *ngIf="sub.icon"></em>
                    <span>{{ (sub.translate | translate) || sub.text }}</span>
                  </a>
                </li>
              </ul>
            </ng-template>
          </li>
        </ng-container>

        <!-- Items gated by ngx-permissions -->
        <ng-template
          [ngxPermissionsOnly]="item.privileges || [item.privilege]"
          *ngIf="item.privilege"
        >
          <li
            [ngClass]="{
              'nav-heading': item.heading,
              active: item.link && isActiveRoute(item.link)
            }"
            [routerLinkActive]="item.submenu ? [] : ['active']"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <ng-template [ngIf]="item.heading">
              <span>{{ (item.translate | translate) || item.text }}</span>
            </ng-template>

            <ng-template [ngIf]="!item.heading && !item.submenu">
              <a
                [routerLink]="item.link"
                [attr.route]="item.link"
                title="{{ item.text }}"
              >
                <span
                  class="pull-right"
                  *ngIf="item.alert"
                  [ngClass]="item.label || 'label label-success'"
                  >{{ item.alert }}</span
                >
                <em class="{{ item.icon }}" *ngIf="item.icon"></em>
                <span>{{ (item.translate | translate) || item.text }}</span>
              </a>
            </ng-template>

            <ng-template [ngIf]="!item.heading && item.submenu">
              <a
                class="nav-item"
                title="{{ item.text }}"
                [routerLink]="item.link"
                [attr.route]="item.link"
                (click)="ensureSubmenuOpen(item)"
              >
                <span class="pull-right">
                  <em
                    class="fa cursor-pointer"
                    style="padding: 0 4px"
                    [ngClass]="
                      isSubmenuOpen(item) ? 'fa-angle-down' : 'fa-angle-left'
                    "
                    (click)="toggleSubmenu($event, item)"
                  ></em>
                </span>
                <em class="{{ item.icon }}" *ngIf="item.icon"></em>
                <span>{{ (item.translate | translate) || item.text }}</span>
              </a>
              <ul
                class="nav sidebar-subnav"
                [class.in]="isSubmenuOpen(item)"
                [style.display]="isSubmenuOpen(item) ? 'block' : 'none'"
              >
                <li class="sidebar-subnav-header">{{ item.text }}</li>
                <li
                  *ngFor="let sub of item.submenu"
                  [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{ exact: sub.link === '/superadmin' || sub.link === item.link }"
                >
                  <a
                    [routerLink]="sub.link"
                    [attr.route]="sub.link"
                    title="{{ sub.text }}"
                  >
                    <em class="{{ sub.icon }}" *ngIf="sub.icon"></em>
                    <span>{{ (sub.translate | translate) || sub.text }}</span>
                  </a>
                </li>
              </ul>
            </ng-template>
          </li>
        </ng-template>
      </ng-template>
    </ul>
    <ng-template [ngIf]="parent_account_id == '1'">
      <ul class="nav align-content-end">
        <li class="bg-default">
          <a (click)="showIntercom()">
            <em class="icon-support"></em>
            <span>Live Chat&nbsp;</span>
          </a>
        </li>
        <li class="bg-default">
          <a href="http://support.marketingoptimizer.com" target="_new">
            <em class="icon-docs"></em>
            <span>Documentation&nbsp;</span>
          </a>
        </li>
        <li class="bg-default">
          <a [routerLink]="['/get-started']">
            <em class="icon-question"></em>
            <span>Get Started&nbsp;</span>
          </a>
        </li>
      </ul>
    </ng-template>
  </nav>
<!-- </div> -->
